// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JoinStreamingButton__button-d76cd3 {
  align-items: center;
  display: flex;
  color: var(--addition-50);
  background-color: var(--addition-160);
  border-radius: 14px;
  padding: 0 8px 0 6px;
  height: 28px;
}

.JoinStreamingButton__button-d76cd3.JoinStreamingButton__canPress-a9f7ec:not(:disabled) {
  cursor: pointer;
}

.JoinStreamingButton__button-d76cd3.JoinStreamingButton__canPress-a9f7ec:not(:disabled):hover,
.JoinStreamingButton__button-d76cd3.JoinStreamingButton__canPress-a9f7ec:not(:disabled):focus,
.JoinStreamingButton__button-d76cd3.JoinStreamingButton__canPress-a9f7ec:not(:disabled):active {
  background-color: var(--addition-170);
}

.JoinStreamingButton__button-d76cd3:disabled {
  color: var(--addition-160);
  background-color: transparent;
  padding: 0;
}

.JoinStreamingButton__icon-b3a70c {
  fill: currentColor;
  margin-inline-end: 5px;
}

.JoinStreamingButton__label-c0e710 {
  font: var(--font-caption-4);
  letter-spacing: var(--font-spacing-caption-4);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/components/JoinStreamingButton/JoinStreamingButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,qCAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;;;EAGE,qCAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,2BAAA;EACA,6CAAA;AACF","sourcesContent":[".button {\n  align-items: center;\n  display: flex;\n  color: var(--addition-50);\n  background-color: var(--addition-160);\n  border-radius: 14px;\n  padding: 0 8px 0 6px;\n  height: 28px;\n}\n\n.button.canPress:not(:disabled) {\n  cursor: pointer;\n}\n\n.button.canPress:not(:disabled):hover,\n.button.canPress:not(:disabled):focus,\n.button.canPress:not(:disabled):active {\n  background-color: var(--addition-170);\n}\n\n.button:disabled {\n  color: var(--addition-160);\n  background-color: transparent;\n  padding: 0;\n}\n\n.icon {\n  fill: currentColor;\n  margin-inline-end: 5px;\n}\n\n.label {\n  font: var(--font-caption-4);\n  letter-spacing: var(--font-spacing-caption-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `JoinStreamingButton__button-d76cd3`,
	"canPress": `JoinStreamingButton__canPress-a9f7ec`,
	"icon": `JoinStreamingButton__icon-b3a70c`,
	"label": `JoinStreamingButton__label-c0e710`
};
module.exports = ___CSS_LOADER_EXPORT___;
